/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {

    export class ProcessEventConfigurationModel {
        processEventConfigurations: Wars.Domain.Model.ProcessEventConfiguration[];
        systemLevel: Wars.Domain.Model.SystemLevel;
        systemActions: Wars.Domain.Model.SystemAction[];
        processActions: Wars.Domain.Model.ProcessAction[];
        selectedProcessEvent: Wars.Domain.Model.ProcessEventConfiguration;
        isSystem: boolean;

        constructor(
            private processConfigurationId: string,
            private processEventConfigurationService: services.ProcessEventConfigurationService,
            private securityMatrixService: services.SecurityMatrixService,
            private systemLevelService: services.SystemLevelService,
            private processActionService: services.ProcessActionService,
            private deleteService: services.DeleteService) {

            if (processConfigurationId) {
                this.isSystem = false;
                this.processEventConfigurationService.getProcessEventConfigurations(processConfigurationId)
                    .then(eventConfigurations => {
                        this.processEventConfigurations = eventConfigurations;
                    });
            } else {
                this.isSystem = true;
                this.systemLevelService.getSystemLevelProcessEventConfigurations()
                    .then(systemLevel => {
                        this.systemLevel = systemLevel;
                        this.processEventConfigurations = systemLevel.myProcessEventConfigurations;
                    });
            }

            this.processActionService.getAllProcessActions(processConfigurationId).then(
                (processActions) => {
                    this.processActions = processActions;
                });

            this.systemLevelService.getSystemLevelSystemActions().then(
                (systemLevel) => {
                    this.systemActions = systemLevel.mySystemActions;
                });
        }

        public addProcessEventConfiguration() {
            var initiateSecurityMatrix = this.securityMatrixService.createSecurityMatrix(this.isSystem);
            var viewSecurityMatrix = this.securityMatrixService.createSecurityMatrix(this.isSystem);

            var processEventConfiguration = this.processEventConfigurationService.createProcessEventConfiguration();
            if (this.processConfigurationId) {
                processEventConfiguration.processConfiguration_id = this.processConfigurationId;
            } else {
                processEventConfiguration.systemLevel_id = this.systemLevel.id;
            }
            processEventConfiguration.initiateSecurityMatrix_id = initiateSecurityMatrix.id;
            processEventConfiguration.viewSecurityMatrix_id = viewSecurityMatrix.id;
            processEventConfiguration.name = "Event";
            processEventConfiguration.allowComment = false;
            processEventConfiguration.allowAttachments = false;
            processEventConfiguration.uniqueIdentifier = services.UtilityService.generateGuidComb();

            this.processEventConfigurationService.saveAllChanges(() => {
                this.processEventConfigurations.push(processEventConfiguration);
                this.selectedProcessEvent = processEventConfiguration;
            });
        }

        public openInitiateSecurityMatrixModal(processEventConfiguration: Wars.Domain.Model.ProcessEventConfiguration) {
            this.securityMatrixService.fetchById(processEventConfiguration.initiateSecurityMatrix_id, "SecurityMatrix")
                .then((securityMatrix) => {
                    this.securityMatrixService.openSecurityMatrixModal(securityMatrix, this.processConfigurationId);
                });
        }

        public openViewSecurityMatrixModal(processEventConfiguration: Wars.Domain.Model.ProcessEventConfiguration) {
            this.securityMatrixService.fetchById(processEventConfiguration.viewSecurityMatrix_id, "SecurityMatrix")
                .then((securityMatrix) => {
                this.securityMatrixService.openSecurityMatrixModal(securityMatrix, this.processConfigurationId);
                });
        }

        public editProcessEventConfiguration(processEventConfiguration: Wars.Domain.Model.ProcessEventConfiguration): void {
            this.selectedProcessEvent = processEventConfiguration;
        }

        public closeEdit(): void {
            this.selectedProcessEvent = undefined;
        }

        public removeProcessEventConfiguration(processEventConfiguration: Wars.Domain.Model.ProcessEventConfiguration): void {
            this.deleteService.deleteWithModalConfirmIfNecessary(
                "ProcessEventConfiguration",
                processEventConfiguration.id,
                "Process Event Configuration",
                () => {
                    this.processEventConfigurations.remove(processEventConfiguration);
                });
        }

        public updateProcessEventConfiguration() {
            this.processEventConfigurationService.saveAllChanges();
        }
    }
}